import * as React from "react";


export const Legends = ({ colors, showUnknown }) => {
    const genders = showUnknown ? ['Female', 'Male', 'Unknown'] : ['Female', 'Male'];
    return <div className="team-legend-container">
        {genders.map(gender => <div key={gender} className="team-legend">
            <span style={{ background: colors[gender] }} className="team-legend-colorblock"></span>
            <span className="team-legend-text">{gender}</span>
        </div>)}
    </div>
}